import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom"
import { logUI } from "../../api/andyliticsApi";
import * as types from "../../constants/actionTypes"
import * as Tools from "../../helpers/Tools"
import { Typography, Tooltip, Icon, Modal, Checkbox } from "../ecosystem/";
import { IconButton } from "../ecosystem/mybswh";
import { InHomeMainPanel, InHomeQuestionsHeading } from "./layout"
const Questionnaires = ({
    history, questions, inReverse, setVaccineIsRemoved, removedVaccines, isLastPatient,
    selectedVaccines, dictionary, onNext, onPrevious, sendResponse, firstName, mrn,
    cancelInHomeBooking, removeVaccine,
    heading, subheading
}) => {

    const [currentIndex, setCurrentIndex] = useState(0);
    const [isLastQuestion, setIsLastQuestion] = useState(false);
    const [isTooltTipOpen, canShowToolTip] = useState(false);
    const [openModal, canOpenPopup] = useState(false);
    const [selectedQuestions, setSelectedQuestions] = useState([]);
    const [vaccinesLeft, setVaccinesLeft] = useState(0);
    const individualResponses = useRef([]);

    useEffect(() => {
        if (!questions) return;
        setIsLastQuestion(currentIndex === questions.length - 1)

    }, [questions, currentIndex])

    useEffect(() => {
        if (!questions || !questions.length) return;
        if (inReverse) {
            if (removedVaccines[mrn] && removedVaccines[mrn].find((v => v === questions[questions.length - 1].vaccineName))) {
                onClickPrevious(questions.length - 2);
            } else {
                setCurrentIndex(questions.length - 1);
            }
        } else {
            if (removedVaccines[mrn] && removedVaccines[mrn].find((v => v === questions[0].vaccineName))) {
                goToNextPage(1);
            } else {
                setCurrentIndex(0)
            }
        }
    }, [questions, inReverse])

    useEffect(() => {
        let vaxLeft = selectedVaccines.reduce((acc, u) => {
            u.vaccines_groups.forEach(group => {
                group.vaccines.forEach((v) => {
                    if (v.isChecked) acc++;
                })
            })
            return acc;
        }, 0)
        setVaccinesLeft(vaxLeft);
    }, [selectedVaccines])


    const goToNextPage = (potentialIndex = undefined) => {

        if (!isNaN(potentialIndex)) {

            if (potentialIndex > questions.length - 1) {
                onNext(individualResponses.current)
            } else {
                //skip next question if it was removed
                if (removedVaccines[mrn] && removedVaccines[mrn].find((v => v === questions[potentialIndex].vaccineName))) {
                    goToNextPage(potentialIndex + 1);
                }
                else {
                    setCurrentIndex(potentialIndex)
                }
            }

        } else {

            if (selectedQuestions.length) {
                let userResponses = {
                    mrn: mrn,
                    vaccineName: questions[currentIndex].vaccineName,
                    vaccineResponses: selectedQuestions?.map((questionIndex) => {
                        return questions[currentIndex].items[questionIndex];
                    })
                }

                individualResponses.current.push(userResponses);
                setSelectedQuestions([]);
            }

            if (currentIndex === questions.length - 1) {
                onNext(individualResponses.current)
            } else {
                if (removedVaccines[mrn] && removedVaccines[mrn].find((v => v === questions[currentIndex + 1].vaccineName))) {
                    //skip next question if it was removed
                    goToNextPage(currentIndex + 2)
                }
                else {
                    setCurrentIndex(currentIndex + 1)
                }
            }

        }
    }

    const onClickPrevious = (potentialIndex = undefined) => {

        if (!isNaN(potentialIndex)) {

            if (potentialIndex < 0) {
                onPrevious()
            } else {
                if (removedVaccines[mrn] && removedVaccines[mrn].find((v => v === questions[potentialIndex].vaccineName))) {
                    //skip next question if it was removed
                    onClickPrevious(potentialIndex - 1);
                }
                else {
                    setCurrentIndex(potentialIndex)
                }
            }

        } else {
            if (currentIndex === 0) {
                onPrevious()
            } else {
                if (removedVaccines[mrn] && removedVaccines[mrn].find((v => v === questions[currentIndex - 1].vaccineName))) {
                    //skip next question if it was removed
                    onClickPrevious(currentIndex - 2)
                }
                else {
                    setCurrentIndex(currentIndex - 1)
                }
            }
        }
    }

    function onClickOnCheckBox(i) {
        markSelected(i);
    }

    const markSelected = (i) => {
        let arr = selectedQuestions;
        const isMarked = arr.includes(i);
        arr = arr.filter(item => item !== i)
        if (isMarked) {
            setSelectedQuestions([...arr])
        } else {
            setSelectedQuestions([...arr, i])
        }

    }

    const canShowPopup = () => {
        canOpenPopup(!openModal);
    }

    const toggleToolTip = () => {
        canShowToolTip(!isTooltTipOpen);
    }

    const onClickNext = () => {
        if (selectedQuestions.length > 0) {
            canShowPopup();
            if (isLastPatient && isLastQuestion) logUI(`MBHWeb.UI.InHomeSchedulingEligibility.NotEligible`, new Date(), Tools.getURLPath());
        } else {
            goToNextPage();
        }
    }

    const makeTooltipContentTag = (item) => {
        let tempItem = item;
        let temp = <span id="tooltip">allergic reaction</span>;
        let items = tempItem.split("allergic reaction");
        return <div>{item}</div>;
    }

    const onClickOnCloseButton = () => {
        canOpenPopup(false);
    }

    const closeModal = () => {
        removeVaccine(mrn, questions[currentIndex].vaccineName)
        setVaccineIsRemoved(mrn, questions[currentIndex].vaccineName)
        canOpenPopup(false);
        goToNextPage();
    }

    const handleCancelBooking = (goHome = false) => {
        if (selectedQuestions.length) {
            let userResponses = {
                mrn: mrn,
                vaccineName: questions[currentIndex].vaccineName,
                vaccineResponses: selectedQuestions?.map((questionIndex) => {
                    return questions[currentIndex].items[questionIndex];
                })
            }

            individualResponses.current.push(userResponses);
        }
        sendResponse(individualResponses.current);
        if (goHome) navigateToHome();
        logUI(`MBHWeb.UI.InHomeSchedulingEligibility.Cancel.Clicked`, new Date(), Tools.getURLPath());
        //cancelInHomeBooking()
        canOpenPopup(false);
    }

    const navigateToHome = () => {
        //debugger;
        canOpenPopup(false);
        history.push("/");
    }

    const toolTipText = "Most allergic reactions are mild to moderate, and do not cause major problems. However, a small number of people may experience a severe allergic reaction called anaphylaxis, which requires immediate life saving medication."
    return (
        <InHomeMainPanel
            heading={heading}
            subheading={subheading}
            schedulingButtons={{
                leftOnClick: onClickPrevious,
                rightOnClick: onClickNext
            }}
        >
            <div className="row question-wrapper">
                <div className="col-12 col-lg-10 eligibility-detail-wrapper">
                    {
                        questions?.map((que, index) => {
                            return currentIndex === index && <div key={`question-${index}`}>
                                <div className="vaccine-question-wrapper">
                                    <InHomeQuestionsHeading
                                        heading={que.vaccineName}
                                    />
                                    <div className="vaccine-question-wrapper__group select-group-wrapper">
                                        {
                                            que.items?.map((item, i) => {
                                                return <div className="vaccine-question-wrapper__item" key={`item-${i}`}>
                                                    {item.includes("allergic reaction") ?
                                                        <div className="vaccine-question-wrapper__tooltip">
                                                            <Tooltip
                                                                text={toolTipText}
                                                                tooltipId={`allergy-reaction-tooltip-${i}`}
                                                                placement="left"
                                                            >
                                                                <IconButton
                                                                    icon="information"
                                                                    ariaDescribedBy={`allergy-reaction-tooltip-${i}`}
                                                                />
                                                            </Tooltip>
                                                        </div>
                                                        :
                                                        null
                                                    }
                                                    <Checkbox
                                                        onClick={() => onClickOnCheckBox(i)}
                                                        label={<span dangerouslySetInnerHTML={{ __html: item }} />}
                                                        value={selectedQuestions?.length > 0 ? selectedQuestions.indexOf(i) !== -1 : false}
                                                        variant="select"
                                                    />
                                                </div>
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                        })
                    }
                    {questions && <div>
                        <Modal
                            isOpen={openModal}
                            //onCloseClick={onClickOnCloseButton}
                            //className="inhome-modal"
                            modalHeader={<>
                                {isLastPatient && isLastQuestion && vaccinesLeft === 1 ?
                                    `You’re not eligible for the vaccine(s) that you’ve requested.`
                                    :
                                    `${firstName} is not eligible for the ${questions[currentIndex]?.vaccineName}`
                                }
                            </>}
                            modalBody={<>
                                {
                                    isLastPatient && isLastQuestion && vaccinesLeft === 1 ?
                                        `Unfortunately your responses indicate that we can not administer the vaccine (or vaccines) you’ve asked for at this time.`
                                        :
                                        `You can continue booking this appointment but this vaccine will be removed from the request.`
                                }
                            </>}
                            modalFooterButtons={
                                isLastPatient && isLastQuestion && vaccinesLeft === 1 ?
                                    [{ label: "Back to home", onClick: navigateToHome }]
                                    :
                                    [{ label: "Continue", onClick: closeModal },
                                    { label: "Cancel booking", onClick: handleCancelBooking }]
                            }
                        />
                    </div>}
                </div>
            </div>
        </InHomeMainPanel>
    )
}

const mapDispatchToProps = (dispatch) => {
    return {
        cancelInHomeBooking: () => dispatch({ type: types.CANCEL_INHOME_BOOKING }),
        removeVaccine: (userMrn, vaccineName) => dispatch({ type: types.REMOVE_VACCINE, userMrn, vaccineName }),
    }
}

export default connect(null, mapDispatchToProps)(Questionnaires);